import { render, staticRenderFns } from "./action-free-block.vue?vue&type=template&id=96e51898&scoped=true"
import script from "./action-free-block.vue?vue&type=script&lang=js"
export * from "./action-free-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e51898",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96e51898')) {
      api.createRecord('96e51898', component.options)
    } else {
      api.reload('96e51898', component.options)
    }
    module.hot.accept("./action-free-block.vue?vue&type=template&id=96e51898&scoped=true", function () {
      api.rerender('96e51898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/landing-page/components/setting-blocks/components/action-free-block.vue"
export default component.exports